<template>
  <div v-if="test.exam" class="block lg:flex flex-row items-center justify-between bg-white rounded-md shadow overflow-x-auto mb-2 hover:bg-gray-100">

    <div class="lg:flex-1 flex p-6 bg-transparent focus:text-primary-500 flex-col items-start lg:w-[200px] xl:w-[400px]">
      <div class="font-medium text-secondary-500 text-lg mb-2">{{ test.exam.name }}</div>
      <div class="text-sm text-gray-500">
        Vom {{ moment(test.created_at).format('DD.MM.YYYY HH:mm') }} -
        <span v-if="isFinished" class="">{{ test.estimated_time ? test.estimated_time : 0 }} Min.</span>
        <span v-else-if="hasExpired" class="">Test abgelaufen</span>
        <span v-else class=""></span>
      </div>
    </div>

    <div v-if="isFinished || hasExpired" class="lg:flex-1 px-6 lg:p-6">
      <div class="mb-3"><span v-if="test.result"><span class="inline-block lg:hidden xl:inline-block">Ergebnis</span> {{ test.result.percentage }}%</span> <span :class="badgeClasses" class="ml-4 text-white text-xs font-semibold mr-2 px-2.5 py-0.5 rounded">{{ statusTxt }}</span></div>
      <div v-if="test.result" class="text-sm text-gray-500">{{ questionCount }} Fragen / {{ test.result.answered_right.length }} richtig / {{ test.result.answered_wrong.length }} falsch</div>
    </div>

    <span v-else class="lg:flex-1 p-6 lg:p-6">
      <div class=""><span :class="badgeClasses" class="text-white text-xs font-semibold mr-2.5 ml-6 px-2.5 py-0.5 rounded">{{ statusTxt }}</span></div>
    </span>

    <div class="flex-1 lg:flex justify-end gap-2 pr-6 pl-6 lg:pl-2 py-6 lg:py-0 block lg:flex h-100 align-bottom lg:mt-4 gap-2">
      <div v-if="canBeContinued" class="lg:flex lg:gap-2">
        <Link :href="itemLink" class="btn-success block w-100 lg:w-[160px] lg:inline-block mb-2 lg:mb-0">Fortsetzen</Link>
        <Link :href="'/test/delete/' + test.id" class="btn-danger block w-100 lg:inline-block"> <i class="fa fa-trash mr-1"></i> Löschen</Link>
      </div>
      <div v-else class=" py-6 lg:py-0 block lg:flex h-100 align-bottom lg:mt-4 gap-2">
        <Link :href="'/testergebnis/' + test.id" class="btn-primary block w-100 lg:inline-block mb-2 lg:mb-0">Details</Link>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import {Link} from '@inertiajs/inertia-vue3'

/**
 * Shows all tests (not exams) and the status for the current user
 *
 * @author Darius Mozgiel | mozgiel.de
 */
export default {
  name: 'TestItem',

  props: {
    test: Object,
  },

  components: {
    Link,
  },

  data() {
    return {
      moment: moment,
    }
  },

  computed: {

    threshold: function() {
      // if this.$page.props.app.threshold is not set, use 60 as default
      return this.$page.props.app.threshold ? this.$page.props.app.threshold + 1 : 60
    },

    itemLink: function() {
      return this.canBeContinued ? `/exam/${this.test.exam_id}` : `/testergebnis/${this.test.id}`
    },

    questionCount: function() {
      if( this.test.result ) {
        return this.test.result.question_count
      } else {
        return this.test.exam.questions.length
      }
    },

    hasExpired: function() {
      let date = Date.parse(this.test.ends_at)
      let now = Date.now()
      return date < now
    },

    isFinished: function() {
      let status = parseInt( this.test.status )
      return  status === 2 || status === 3
    },

    canBeContinued: function() {
      let status = parseInt( this.test.status )
      return status === 1 && !this.isFinished && !this.hasExpired
    },

    badgeClasses: function() {
      if( this.canBeContinued ) {
        return 'bg-primary-500'
      } else if( ( this.test.result && this.test.result.percentage < this.threshold ) || ( !this.isFinished && this.hasExpired) ) {
        return 'bg-red-500'
      } else {
        return 'bg-success-500'
      }
    },
    statusTxt: function() {
      if( this.test.paused_with_minutes_left ) {
        return this.__('test.paused')
      } else if( this.canBeContinued ) {
        return this.__('test.still_time_until') + ' ' + moment( this.test.ends_at ).format('DD.MM.YYYY HH:mm')
      } else if( parseInt( this.test.status ) === 4 ) {
        return this.__('test.gone')
      } else if( ( this.test.result && this.test.result.percentage < this.threshold ) || ( !this.isFinished && this.hasExpired) ) {
        return this.__('test.failed')
      } else {
        return this.__('test.passed')
      }
    },
  },

  mounted() {

  },
}
</script>

<style scoped>

</style>
